import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const RacingContext = createContext(null);
export const useRacing = () => useContext(RacingContext);

export function RacingProvider({ children }) {
  const { isAuthed } = useAuth();
  const [runs, setRuns] = useState([]);
  const [pitCrew, setPitCrew] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const [r, p] = await Promise.all([api.get("/runs"), api.get("/pit-crew")]);
      setRuns(r.data);
      setPitCrew(p.data);
    } catch (e) {
      // ignore
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (isAuthed) refresh();
    else {
      setRuns([]);
      setPitCrew([]);
    }
  }, [isAuthed, refresh]);

  const addRun = async (run) => {
    const { data } = await api.post("/runs", run);
    setRuns((prev) => [data, ...prev.filter((x) => x.id !== data.id)].sort((a, b) => (b.date || "").localeCompare(a.date || "")));
    return data;
  };

  const updateRun = async (id, run) => {
    const { data } = await api.put(`/runs/${id}`, run);
    setRuns((prev) => prev.map((x) => (x.id === id ? data : x)).sort((a, b) => (b.date || "").localeCompare(a.date || "")));
    return data;
  };

  const deleteRun = async (id) => {
    await api.delete(`/runs/${id}`);
    setRuns((prev) => prev.filter((x) => x.id !== id));
  };

  const addPitCrewMember = async (member) => {
    const { data } = await api.post("/pit-crew", member);
    setPitCrew((prev) => [...prev, data]);
    return data;
  };

  const removePitCrewMember = async (id) => {
    await api.delete(`/pit-crew/${id}`);
    setPitCrew((prev) => prev.filter((x) => x.id !== id));
  };

  return (
    <RacingContext.Provider
      value={{ runs, pitCrew, loaded, refresh, addRun, updateRun, deleteRun, addPitCrewMember, removePitCrewMember }}
    >
      {children}
    </RacingContext.Provider>
  );
}
